module.exports = __webpack_public_path__ + "static/img/copycheck_jianjie.fc5924b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/copycheck_jianjie.jpg
// module id = qBCJ
// module chunks = 25